/** Un mes contable: año y mes (1-12). */
export type Periodo = { anio: number; mes: number }

export const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']

export const nombreDePeriodo = (anio: number, mes: number) => `${MESES[mes - 1]} ${anio}`

/** Los 24 periodos que un despacho consulta en la práctica, en un solo control (RF-701). */
export function periodosDisponibles(hoy: Date): Periodo[] {
  const lista: Periodo[] = []
  for (let i = 0; i < 24; i++) {
    const d = new Date(hoy.getFullYear(), hoy.getMonth() - i, 1)
    lista.push({ anio: d.getFullYear(), mes: d.getMonth() + 1 })
  }
  return lista
}
